import { createApiClient } from '../../../../../api/apiClient';
import { OrderRulesAutocompletePayload, OrderRulesAutocompleteResponse, OrderRulesFilterDataResponse } from './types';

// ─── API: /api/order-rules/filter-data ───────────────────────────────────────

export const fetchOrderRulesFilterData = async (): Promise<OrderRulesFilterDataResponse> => {
  const api = createApiClient();
  const res = await api.get<{ data: OrderRulesFilterDataResponse; success: boolean; message: string }>(
    '/order-rules/filter-data',
  );
  return (res.data as any)?.data ?? res.data;
};

// ─── API: POST /api/order-rules/autocomplete/filter-data ─────────────────────

export const fetchOrderRulesFilterDataAutocomplete = async (
  payload: OrderRulesAutocompletePayload,
): Promise<OrderRulesAutocompleteResponse> => {
  const api = createApiClient();
  const res = await api.post<{ data: OrderRulesAutocompleteResponse; success: boolean; message: string }>(
    '/order-rules/autocomplete/filter-data',
    payload,
  );
  return (res.data as any)?.data ?? res.data;
};
